import React, { Component } from 'react';
import YouTube from 'react-youtube';
import { Grid, Row, Col, Thumbnail, Button, Panel, PanelGroup, Image, Collapse, Fade, Carousel } from 'react-bootstrap';

import { AwesomeButton, AwesomeButtonSocial } from 'react-awesome-button';
import 'react-awesome-button/dist/styles.css';
import 'react-awesome-button/dist/themes/theme-blue.css';

import { AutoAffix } from 'react-overlays';

import PanelContent from './PanelContent';
import PanelBlurb from './PanelBlurb';

import StarsContent from './StarsContent';
import StarsBlurb from './StarsBlurb';

import TinyEngineContent from './TinyEngineContent';
import TinyEngineBlurb from './TinyEngineBlurb';

import MyCol from './MyCol';

import './ThumbnailGrid.css'

export default class ThumbnailGrid extends React.Component {
    constructor(props, context) {
      super(props, context);

      this.handleSelect = this.handleSelect.bind(this);

      this.state = {
        activeKey: '0'
      };
    }

    handleSelect(activeKey) {
      // alert("activeKey set from " + this.state.activeKey + " to " + activeKey);

      this.setState({ activeKey });

      // let pixelTopOffset = 0;
      // let pixelsPerRow = 650;
      // let boxesPerRow = 3;
      // let pixelTop = pixelTopOffset + (pixelsPerRow * (Math.floor( (activeKey - 1) / boxesPerRow) + 1));
      // // alert(" " + parseInt( (activeKey - 1) / boxesPerRow));
      // // alert("moving to " + pixelTop);
      //
      // window.scrollTo({
      //   top: pixelTop,
      //   behavior: "smooth"
      // });
      // co
      if (activeKey === '1') {
        console.log('hi');
        document.body.style.backgroundImage = "url('assets/tts/screenshot-1.png')";
      }
      else {
        document.body.style.backgroundImage = "url('assets/tts/test-gif.gif')";
      }
    }

    render() {
      return (
        <div>
          <div>
            <Grid className="myGrid">
              <Row>
                <Col xs={6} md={4}>
                  <div>
                      <Thumbnail className="my-thumbnail" src="assets/tts/title.png" alt="242x200">
                          <StarsBlurb className="blurb"/>

                          <AwesomeButton type="primary" action={() => this.handleSelect("1")}>Show me more!</AwesomeButton>
                      </Thumbnail>
                  </div>
                </Col>

                <Col xs={6} md={4}>
                  <div>
                    <Thumbnail className="my-thumbnail" src="assets/screenshot-2.jpg" alt="242x200" rounded>
                      <h3>Spoiled Tomatillos</h3>
                      <p>LUL</p>
                      <Fade in={this.state.activeKey !== "2"} >
                        <AwesomeButton type="primary" action={() => this.handleSelect("2")}>Show me more!</AwesomeButton>
                      </Fade>
                    </Thumbnail>
                  </div>
                </Col>

                <Col xs={6} md={4}>
                  <div>
                    <Thumbnail className="my-thumbnail" src="assets/tinyengine/title.png" alt="242x200" rounded>
                      <TinyEngineBlurb className="blurb"/>

                      <Fade in={this.state.activeKey !== "3"} >
                        <AwesomeButton type="primary" action={() => this.handleSelect("3")}>Show me more!</AwesomeButton>
                      </Fade>
                    </Thumbnail>
                  </div>
                </Col>

                {/* <Col xs={6} md={4}>
                  <div>
                    <Thumbnail className="my-thumbnail" src="assets/screenshot-1.jpg" alt="242x200">
                      <h3>Thumbnail #4</h3>
                      <p>Blurb #4 - Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris felis sem, tristique et porta vitae, rhoncus eu turpis. Proin convallis, nisi sed feugiat cursus, orci magna euismod quam, et porttitor est mi vel nisl. Curabitur in finibus ligula, vel venenatis elit. Nulla venenatis facilisis commodo. Nam volutpat mollis tincidunt. Nullam sit amet nisl iaculis, finibus nibh a, varius est. Duis eget vestibulum erat, at porta leo. Fusce neque diam, pharetra rutrum eros vitae, rhoncus pharetra mi. Praesent mauris sem, lacinia vitae orci at, rutrum ultrices ipsum. Praesent mattis, nunc eget suscipit elementum, erat sapien lacinia metus, et ultricies enim tellus et neque.</p>
                      <Fade in={this.state.activeKey !== "4"} >
                        <AwesomeButton type="primary" action={() => this.handleSelect("4")}>Show More #4</AwesomeButton>
                      </Fade>
                    </Thumbnail>
                  </div>
                </Col> */}
              </Row>
            </Grid>
          </div>

          <div className="show-hide-panel">
            <Collapse in={this.state.activeKey === "1"} >
              <Panel>
                <Panel.Heading>
                  <div className="btn-group pull-right">
                    <AwesomeButtonSocial type="github" href="https://github.com/GCSChris/Through-The-Stars">Source</AwesomeButtonSocial>
                    <AwesomeButton href="https://chrisdinome.itch.io/through-the-stars">Download</AwesomeButton>
                  </div>

                  <Panel.Title>Through the Stars</Panel.Title>
                </Panel.Heading>

                <Panel.Body>
                  <div className="panel-body-left">
                    <div className="panel-body-text">

                    <StarsContent/>

                    <AwesomeButton type="secondary" action={() => this.handleSelect("0")}>Hide</AwesomeButton>
                    <AwesomeButtonSocial type="github" href="https://github.com/GCSChris/Through-The-Stars">Source</AwesomeButtonSocial>
                    <AwesomeButton href="https://chrisdinome.itch.io/through-the-stars">Download</AwesomeButton>

                    </div>
                  </div>

                  <div className="panel-body-right">

                    <div className="panel-body-video">
                      <YouTube
                        className="yt-video"
                        videoId="G8gfMIPzoUM"
                      />
                    </div>
                  </div>

                  <Grid className="screenshots-group">
                    <Row>
                        <Image src="assets/tts/screenshot-1.png" className="screenshot" rounded/>
                        <Image src="assets/tts/screenshot-2.png" className="screenshot" rounded/>
                        <Image src="assets/tts/screenshot-3.png" className="screenshot" rounded/>
                        <Image src="assets/tts/screenshot-4.png" className="screenshot" rounded/>
                    </Row>
                  </Grid>

                  <AwesomeButton type="secondary" action={() => this.handleSelect("0")}>Hide</AwesomeButton>
                  <AwesomeButtonSocial type="github" href="https://github.com/GCSChris/Through-The-Stars">Source</AwesomeButtonSocial>
                  <AwesomeButton href="https://chrisdinome.itch.io/through-the-stars">Download</AwesomeButton>

                </Panel.Body>

              </Panel>
            </Collapse>

            <Collapse in={this.state.activeKey === "2"} >
              <Panel>
                <Panel.Heading>
                  <div className="btn-group pull-right">
                    <AwesomeButtonSocial type="github" href="GITHUB_TODO">Source</AwesomeButtonSocial>
                  </div>

                  <Panel.Title>Panel #2</Panel.Title>


                </Panel.Heading>

                <Panel.Body>
                  <div className="panel-body-left">
                    <div className="panel-body-text">
                      <p>Talk to trees, look at the birds. Whatever it takes. We'll throw some old gray clouds in here just sneaking around and having fun. If you don't think every day is a good day - try missing a few. You'll see. Now we don't want him to get lonely, so we'll give him a little friend. You're meant to have fun in life. Let's make a nice big leafy tree.</p>

                      <p>We don't have to be committed. We are just playing here. Volunteering your time; it pays you and your whole community fantastic dividends. So often we avoid running water, and running water is a lot of fun.</p>

                      <p>Absolutely no pressure. You are just a whisper floating across a mountain. I'll go over the colors one more time that we use: Titanium white, Thalo green, Prussian blue, Van Dyke brown, Alizarin crimson, Sap green, Cad yellow, and Permanent red. Even trees need a friend. We all need friends. As trees get older they lose their chlorophyll. Follow the lay of the land. It's most important. When things happen - enjoy them. They're little gifts.</p>

                      <p>We have no limits to our world. We're only limited by our imagination. Just take out whatever you don't want. It'll change your entire perspective. Don't fight it, use what happens. Nothing's gonna make your husband or wife madder than coming home and having a snow-covered dinner. Maybe there's a happy little waterfall happening over here.</p>

                      <p>The more we do this - the more it will do good things to our heart. Let's build some happy little clouds up here. Very easy to work these to death. There are no mistakes. You can fix anything that happens. I guess I'm a little weird. I like to talk to trees and animals. That's okay though; I have more fun than most people.</p>

                      <p>And I will hypnotize that just a little bit. Trees grow however makes them happy. Every highlight needs it's own personal shadow. Let's give him a friend too. Everybody needs a friend.</p>

                      <p>You could sit here for weeks with your one hair brush trying to do that - or you could do it with one stroke with an almighty brush. This is probably the greatest thing that's ever happened in my life. This is truly an almighty mountain. We'll play with clouds today. Now, we're going to fluff this cloud. This is gonna be a happy little seascape.</p>

                      <AwesomeButton type="secondary" action={() => this.handleSelect("0")}>Hide More #2</AwesomeButton>
                    </div>
                  </div>


                  <div className="panel-body-right">

                    <div className="panel-body-video">
                      <YouTube
                        classNa me="yt-video"
                        videoId="_OBlgSz8sSM"
                      />
                    </div>

                    <div className="panel-body-video">
                      <YouTube
                        className="yt-video"
                        videoId="_OBlgSz8sSM"
                      />
                    </div>

                    <div className="panel-body-video">
                      <YouTube
                        className="yt-video"
                        videoId="_OBlgSz8sSM"
                      />
                    </div>

                    <div>
                      <AwesomeButtonSocial type="github" href="GITHUB_TODO">Source</AwesomeButtonSocial>
                    </div>

                  </div>

                </Panel.Body>
              </Panel>
            </Collapse>

            <Collapse in={this.state.activeKey === "3"} >
              <Panel>
                <Panel.Heading>
                  <div className="btn-group pull-right">
                    <AwesomeButtonSocial type="github" href="https://github.com/GCSChris/TinyEngine">Source</AwesomeButtonSocial>
                    <AwesomeButton href="https://tinyenginecs4850.wordpress.com/">Website</AwesomeButton>
                  </div>

                  <Panel.Title>TinyEngine</Panel.Title>
                </Panel.Heading>

                <Panel.Body>
                  <div className="panel-body-left">
                    <div className="panel-body-text">

                    <TinyEngineContent/>

                    <AwesomeButton type="secondary" action={() => this.handleSelect("0")}>Hide</AwesomeButton>
                    <AwesomeButtonSocial type="github" href="https://github.com/GCSChris/TinyEngine">Source</AwesomeButtonSocial>
                    <AwesomeButton href="https://tinyenginecs4850.wordpress.com/">Website</AwesomeButton>

                    </div>
                  </div>

                  <div className="panel-body-right">

                    <div className="panel-body-video">
                      <YouTube
                        className="yt-video"
                        videoId="TnI-HnQDgd8"
                      />
                    </div>
                  </div>

                  <Grid >
                    <Row>
                      <Col>
                        <Image src="assets/tinyengine/spaceinvaders.png" className="screenshot" rounded/>
                      </Col>
                    </Row>
                  </Grid>
                </Panel.Body>
              </Panel>
            </Collapse>

            <div>
            <Grid className="myGrid">
              <Row>
                <Col xs={6} md={4}>
                  <div>
                    <Thumbnail className="my-thumbnail" src="assets/screenshot-2.jpg" alt="242x200" rounded>
                      <h3>Thumbnail #4</h3>
                      <p>Blurb #4 - Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris felis sem, tristique et porta vitae, rhoncus eu turpis. Proin convallis, nisi sed feugiat cursus, orci magna euismod quam, et porttitor est mi vel nisl. Curabitur in finibus ligula, vel venenatis elit. Nulla venenatis facilisis commodo. Nam volutpat mollis tincidunt. Nullam sit amet nisl iaculis, finibus nibh a, varius est. Duis eget vestibulum erat, at porta leo. Fusce neque diam, pharetra rutrum eros vitae, rhoncus pharetra mi. Praesent mauris sem, lacinia vitae orci at, rutrum ultrices ipsum. Praesent mattis, nunc eget suscipit elementum, erat sapien lacinia metus, et ultricies enim tellus et neque.</p>
                      <Fade in={this.state.activeKey !== "4"} >
                        <AwesomeButton type="primary" action={() => this.handleSelect("4")}>Show More #4</AwesomeButton>
                      </Fade>
                    </Thumbnail>
                  </div>
                </Col>

                <Col xs={6} md={4}>
                  <div>
                    <Thumbnail className="my-thumbnail" src="assets/screenshot-3.jpg" alt="242x200">
                      <h3>Thumbnail #5</h3>
                      <p>Blurb #5 - Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris felis sem, tristique et porta vitae, rhoncus eu turpis. Proin convallis, nisi sed feugiat cursus, orci magna euismod quam, et porttitor est mi vel nisl. Curabitur in finibus ligula, vel venenatis elit. Nulla venenatis facilisis commodo. Nam volutpat mollis tincidunt. Nullam sit amet nisl iaculis, finibus nibh a, varius est. Duis eget vestibulum erat, at porta leo. Fusce neque diam, pharetra rutrum eros vitae, rhoncus pharetra mi. Praesent mauris sem, lacinia vitae orci at, rutrum ultrices ipsum. Praesent mattis, nunc eget suscipit elementum, erat sapien lacinia metus, et ultricies enim tellus et neque.</p>
                      <Fade in={this.state.activeKey !== "5"} >
                        <AwesomeButton type="primary" action={() => this.handleSelect("5")}>Show More #5</AwesomeButton>
                      </Fade>
                    </Thumbnail>
                  </div>
                </Col>
              </Row>
            </Grid>
          </div>
          </div>
        </div>
      );
    }
  }



// WEBPACK FOOTER //
// ./src/components/ThumbnailGrid.jsx